<template>
    <div class="page page__list">
        <search-bar @search="onSearch" name="title,content,work_task.creator_name,assignee" placeholder="输入关键字查找"
            ref="searchBar" />
        <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
        <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
            <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.id"
                :to="'/oa/worktask/' + item.id">
                <div class="weui-cell__bd">
                    <p>{{ item.title }}</p>
                    <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{ item.createTime }}</p>
                </div>
                <div class="weui-cell__ft">
                    <p>{{ item.assignee }}</p>
                    <span class="list-item-status" :class="{ 'warning': item.status == 0 }">{{ item.status == 1 ? "已完成"
                        :
                        "未完成"}}</span>
                </div>
            </router-link>
        </scroll-list>
        <div class="list-footer">
            <label class="list-footer__label">合计：{{ items.length }}个</label>
        </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
    components: {
        SearchBar,
        FilterBar,
        ScrollList
    },
    mixins: [list],
    data() {
        return {
            listUrl: "/api/oa/worktask/list",
            filters: [
                {
                    type: "date",
                    name: "work_task.create_time"
                },
                {
                    type: "condition",
                    label: "状态",
                    value: -1,
                    options: [
                        {
                            value: -1,
                            label: "全部"
                        },
                        {
                            value: 1,
                            label: "未完成",
                            condition: "work_task.status=0"
                        },
                        {
                            value: 2,
                            label: "已完成",
                            condition: "work_task.status=1"
                        }
                    ]
                }
            ]
        };
    }
};
</script>